import AbstractIceContentController from '../../../abstract/ice-content/controller';

class Controller extends AbstractIceContentController {
    constructor(widget) {
        super(widget);
    }
}

export default Controller;



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/widgets/widget-usp-product/widget/scripts/controller.js